import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Navbar1.css";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Logo from "../Assets/RPM logo_white.png";

function NavComplete() {
  const NavLinkstyle = {
    fontSize: "20px",
    color: "#fff",
  };

  const [scrollTop, setScrollTop] = React.useState(0);
  const [isClicked1, setIsClicked1] = useState(false);
  const [isClicked2, setIsClicked2] = useState(false);
  const [bahasa, setBahasa] = useState("");
  const [isBelow990, setIsBelow990] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollTop(position);
  };
  const handleClick1 = () => {
    setIsClicked1(true);
    setBahasa("indo");
    setTimeout(() => {
      setIsClicked1(false);
      window.location.reload();
    }, 200);
  };
  const handleClick2 = () => {
    setIsClicked2(true);
    setBahasa("ing");
    setTimeout(() => {
      setIsClicked2(false);
      window.location.reload();
    }, 200);
  };
  if (bahasa === "indo") {
    localStorage.removeItem("bahasa");
    localStorage.setItem("bahasa", "indo");
  } else if (bahasa === "ing") {
    localStorage.removeItem("bahasa");
    localStorage.setItem("bahasa", "ing");
  }
  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      setIsBelow990(viewportWidth > 990);
    };

    handleResize(); // initial check

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Navbar
      variant="dark"
      expand="lg"
      fixed="top"
      className={`navbar-utama  ${scrollTop > 100 ? "scrolled  " : ""}`}
    >
      <Container className="justify-content-center " fluid>
        <Navbar.Brand
          href="/"
          style={{
            marginRight: isBelow990 ? "200px" : "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={Logo}
            alt="RPM Automotif Logo"
            style={{
              width: isBelow990 ? "150px" : "120px",
              height: "auto",
            }}
          />
        </Navbar.Brand>
        {isBelow990 ? (
          <Nav
            className=" my-2 my-lg-0 d-flex nunito"
            style={{
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              padding: "5px",
            }}
          >
            <Nav.Link href="/" style={NavLinkstyle} className="nav-link">
              {localStorage.getItem("bahasa") === "ing"
                ? "Home"
                : "Halaman utama"}
            </Nav.Link>
            <Nav.Link
              href="/informasi"
              style={NavLinkstyle}
              className="nav-link"
            >
              {localStorage.getItem("bahasa") === "ing"
                ? "Information"
                : "Informasi"}
            </Nav.Link>
            <Nav.Link href="/Promo" style={NavLinkstyle} className="nav-link">
              Promo
            </Nav.Link>
            <Nav.Link
              href="/testimoni"
              style={NavLinkstyle}
              className="nav-link"
            >
              {localStorage.getItem("bahasa") === "ing"
                ? "Reviews & gallery"
                : "Testimoni & galeri"}
            </Nav.Link>
            <ButtonGroup aria-label="Basic example">
              <Button
                variant="none"
                className={`btn-nav button-effect ${isClicked1 ? "button--click" : ""
                  }`}
                onClick={handleClick1}
              >
                <img
                  src="https://i.ibb.co.com/2F7jMNF/1-1.webp"
                  style={{ width: "30px", whiteSpace: "nowrap" }}
                  className="lang-img"
                  alt="id"
                />
              </Button>
              <Button
                variant="none"
                className={`btn-nav button-effect ${isClicked2 ? "button--click" : ""
                  }`}
                onClick={handleClick2}
              >
                <img
                  src="https://i.ibb.co.com/0nzhdv8/2-1.webp"
                  alt="eng"
                  className="lang-img"
                  style={{ width: "30px", whiteSpace: "nowrap" }}
                />
              </Button>
            </ButtonGroup>
          </Nav>
        ) : (
          <Nav>
            <Button
              variant="none"
              className="home-button"
              style={{ fontSize: "30px" }}
              onClick={handleShow}
            >
              <i className="bi bi-house"></i>
            </Button>
          </Nav>
        )}
        <Modal show={show} onHide={handleClose} className="modal-1">
          <Modal.Header
            style={{
              backgroundColor: "black",
              padding: "1px 1px",
              color: "white",
              fontSize: "25px",
            }}
            className="modal-1-header roleway"
          >
            <Button
              style={{
                position: "relative",
                color: "white",
                border: "none",
                WebkitTextStroke: "0.9px",
                left: "86%",
              }}
              variant="none"
              onClick={handleClose}
            >
              <i className="bi bi-x-lg"></i>
            </Button>
          </Modal.Header>
          <Modal.Body className="modal-1-body nunito">
            <Nav.Link href="/" style={NavLinkstyle} className="nav-link">
              {localStorage.getItem("bahasa") === "ing"
                ? "Home"
                : "Halaman utama"}
            </Nav.Link>
            <Nav.Link
              href="/layanan-harga"
              style={NavLinkstyle}
              className="nav-link"
            >
              {localStorage.getItem("bahasa") === "ing"
                ? "Service & Price"
                : "Layanan & Harga"}
            </Nav.Link>
            <Nav.Link
              href="/informasi"
              style={NavLinkstyle}
              className="nav-link"
            >
              {localStorage.getItem("bahasa") === "ing"
                ? "Information"
                : "Informasi"}
            </Nav.Link>
            <Nav.Link href="/Promo" style={NavLinkstyle} className="nav-link">
              Promo
            </Nav.Link>
            <Nav.Link
              href="/testimoni"
              style={NavLinkstyle}
              className="nav-link"
            >
              {localStorage.getItem("bahasa") === "ing"
                ? "Reviews & gallery"
                : "Testimoni & galeri"}
            </Nav.Link>
            <ButtonGroup aria-label="Basic example">
              <Button
                variant="none"
                className={`btn-nav button-effect ${isClicked1 ? "button--click" : ""
                  }`}
                onClick={handleClick1}
              >
                <img
                  src="https://i.ibb.co.com/2F7jMNF/1-1.webp"
                  style={{ width: "30px", whiteSpace: "nowrap" }}
                  className="lang-img"
                  alt="id"
                />
              </Button>
              <Button
                variant="none"
                className={`btn-nav button-effect ${isClicked2 ? "button--click" : ""
                  }`}
                onClick={handleClick2}
              >
                <img
                  src="https://i.ibb.co.com/0nzhdv8/2-1.webp"
                  alt="eng"
                  className="lang-img"
                  style={{ width: "30px", whiteSpace: "nowrap" }}
                />
              </Button>
            </ButtonGroup>
          </Modal.Body>
        </Modal>
      </Container>
    </Navbar>
  );
}

export default NavComplete;
